import translate from '@/lib/intl/translate';
import userActionTypes from '@/rdx/actionTypes';
import { contributionsService } from '@/services/contributions';
import { transformConstituentDonation } from '@/utils/constituentDataTransformers';
import { createAction } from '@/utils/rdxActions';
import showErrorMessage from '@/utils/toasts/showErrorMessage';
import showSuccessMessage from '@/utils/toasts/showSuccessMessage';

const {
  DONATION_REQUEST,
  DONATION_SUCCESS,
  DONATION_FAILURE,
  DONATION_CREATE_REQUEST,
  DONATION_CREATE_SUCCESS,
  DONATION_CREATE_FAILURE,
  DONATION_CREATE_RESET,
  DONATION_DELETE_REQUEST,
  DONATION_DELETE_SUCCESS,
  DONATION_DELETE_FAILURE,
} = userActionTypes;

const fetchContribution = (donationId) => async (dispatch) => {
  try {
    dispatch(createAction({ type: DONATION_REQUEST }));

    const response = await contributionsService.fetchContribution(donationId);

    dispatch(
      createAction({
        type: DONATION_SUCCESS,
        data: response?.data || {},
      }),
    );
  } catch (error) {
    dispatch(
      createAction({
        type: DONATION_FAILURE,
        error,
      }),
    );
  }
};

const createContribution = (donationData) => async (dispatch) => {
  let response;

  try {
    dispatch(createAction({ type: DONATION_CREATE_REQUEST }));

    response = await contributionsService.createContribution(
      transformConstituentDonation(donationData),
    );

    dispatch(
      createAction({
        type: DONATION_CREATE_SUCCESS,
        data: response?.data || {},
      }),
    );

    showSuccessMessage({
      message: translate('CONTRIBUTION_CREATION_SUCCESS'),
    });
  } catch (error) {
    showErrorMessage({
      message: translate('CONTRIBUTION_CREATION_FAILURE'),
    });

    dispatch(
      createAction({
        type: DONATION_CREATE_FAILURE,
        error,
      }),
    );

    return error;
  }

  return response;
};

// TODO: delete; this appears to be unused
const deleteContribution = (donationId) => async (dispatch) => {
  try {
    dispatch(createAction({ type: DONATION_DELETE_REQUEST }));
    await contributionsService.deleteContribution(donationId);
    dispatch(createAction({ type: DONATION_DELETE_SUCCESS, donationId }));
    showSuccessMessage({
      message: translate('CONTRIBUTION_DELETE_SUCCESS'),
    });
  } catch (error) {
    showErrorMessage({
      message: translate('CONTRIBUTION_DELETE_FAILURE'),
    });
    dispatch(createAction({ type: DONATION_DELETE_FAILURE, error }));
  }
};
const resetDonationForm = () => (dispatch) => {
  dispatch(createAction({ type: DONATION_CREATE_RESET }));
};

export const contributionActions = {
  createContribution,
  deleteContribution,
  fetchContribution,
  resetDonationForm,
};
